import React, { useEffect, useState } from "react";
import Modal from "components/ui/Modal";
import "../../../../styles/sharelinkmodal.css";
import { Box, FormControl, FormLabel, Grid, OutlinedInput, Typography, useMediaQuery, styled } from "@mui/material";
import Button from "components/ui/Button";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import custumTheme from "../../../../../../thems/catalogueShareLinkThems";
import PhoneInput from "react-phone-input-2";
import { useCatalogSettingContext } from "context/CatalogSettingContext";
import "react-phone-input-2/lib/style.css";
import apiClient from "lib/api-client";
import debounce from "lodash.debounce";
import CustomSelect from "components/ui/FilterModal/CustomSelect";
import { getLimits } from "features/Setting/Limits/api/limitsApis";
import { toast } from "react-toastify";
import { usePermissions } from "context/PermissionsContext";

const CustomButton = styled(Button)(({}) => ({
  width: "61%",
  fontFamily: "Karla",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "22px",
  height: "50px",
  borderRadius: "5px",
  color: "#00000",
  border: `1px solid #ffffff `,
  textTransform: "none",
  backgroundColor: "#50C878",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#50C878",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#444444",
    color: "#000000",
    border: "1px solid #444444",
  },
}));

const fetchClientName = async (value, setLinkData, setIsAlredyFetch) => {
  setIsAlredyFetch(false);
  try {
    const response = await apiClient.post("/api/v1/catalogSetting/catalog-client/getClientName", {
      mobileNumber: value,
    });

    if (response.status === 200) {
      const clientName = response.data?.clientName || "";
      const clientEmail = response.data?.clientEmail || "";
      const bookType = response.data?.bookType || "";

      if (clientName || clientEmail || bookType) {
        setLinkData((data) => ({
          ...data,
          clientName,
          clientEmail,
          bookType,
        }));
        setIsAlredyFetch(true);
      } else {
        setIsAlredyFetch(false);
        setLinkData((data) => ({
          ...data,
          clientName: "",
          clientEmail: "",
          bookType: "",
        }));
      }
    }
  } catch (error) {
    console.error("Error fetching client name:", error);
  }
};

const debouncedFetchClientName = debounce(fetchClientName, 500);

function CatalogueAddAndEditClientDetails({ open, setOpen, handleRef, isError, isSuccess, isLoading }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { updateClient, setUpdateClient, isEditClinet, setIsEditClinet } = useCatalogSettingContext();
  const [isAlredyFetch, setIsAlredyFetch] = useState(false);
  const [linkData, setLinkData] = useState({
    clientName: "",
    mobileNumber: "",
    clientEmail: "",
    bookType: "",
    hours: "",
  });

  const permissions = usePermissions();

  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const handleOnChangeEvent = (e) => {
    const { name, value } = e.target;
    console.log("Name and Value", name, value);
    setLinkData((data) => ({
      ...data,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    setLinkData((data) => ({
      ...data,
      mobileNumber: value,
    }));

    if (!isEditClinet && value && value.length >= 5) {
      const newMobileNumber = `+91 ${value.slice(2)}`;
      debouncedFetchClientName(newMobileNumber, setLinkData, setIsAlredyFetch);
    }
  };

  const handleClose = () => {
    setOpen(false);
    handleResetForm();
    setUpdateClient({});
    setIsAlredyFetch(false);
  };

  const handleValidation = (inputNumber, country) => {
    const dialCode = country.dialCode;
    const cleanedNumber = inputNumber.replace(/\s+/g, "");
    // For India, ensure it's exactly 10 digits after the country code
    if (dialCode === "91") {
      const numberWithoutCode = cleanedNumber.replace(`${dialCode}`, "");
      return numberWithoutCode.length === 10;
    }

    // For other countries, check if the number length matches the country's typical length
    let typicalLength = country.format.match(/\./g)?.length;
    let numberWithoutCode = cleanedNumber.replace(`${dialCode}`, "");
    numberWithoutCode = `${dialCode}${numberWithoutCode}`;
    if (typicalLength >= 17) {
      typicalLength = 15;
    }
    return numberWithoutCode.length === typicalLength;
  };

  const handleSubmitForm = async () => {
    const newMobileNumber = `+91 ${linkData.mobileNumber.slice(2)}`;
    const newData = isEditClinet
      ? {
          ...updateClient,
          mobileNumber: newMobileNumber,
          clientName: linkData.clientName,
        }
      : {
          // id: Math.floor(1000 + Math.random() * 9000),
          mobileNumber: newMobileNumber,
          clientName: linkData.clientName,
          clientEmail: linkData.clientEmail,
          bookType: linkData.bookType,
          hours: Number(linkData.hours),
          // firstLogIn: 0,
          // noOfLogIn: 0,
        };

    //check limit
    const userData = localStorage.getItem("userData");
    const userDataParsed = JSON.parse(userData);
    let data = await getLimits(userDataParsed?._id);
    let hourLimit = data?.exists?.accessTimeLimitHours;

    if (hourLimit < Number(linkData.hours) && !permissions?.isAdmin) {
      return toast.error(`You can have a maximum of ${hourLimit} hour limit.`);
    }
    handleRef(newData);
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      setOpen(true);
    }
  }, [isError]);

  const handleResetForm = () => {
    setLinkData({
      clientName: "",
      mobileNumber: "",
      clientEmail: "",
      bookType: "",
      hours: "",
    });
  };

  useEffect(() => {
    if (isEditClinet && updateClient) {
      setIsAlredyFetch(false);
      setLinkData({
        clientName: updateClient.clientName || "",
        mobileNumber: updateClient.mobileNumber || "",
        clientEmail: updateClient.clientEmail || "",
        bookType: updateClient.bookType || "",
        hours: "",
      });
    }
  }, [updateClient, isEditClinet]);

  return (
    <ThemeProvider theme={custumTheme}>
      <Modal open={open} handleClose={handleClose} style={{ width: isSmallScreen ? "438px" : "438px", mr: 2.5 }}>
        <Grid container spacing={2.5}>
          <Grid item lg={12}>
            <Typography className="catalogue-share-link-modal-heading">{!isEditClinet ? "Share Catalog" : "Edit Client Details"}</Typography>
          </Grid>

          <Grid item lg={12} width={"100%"}>
            <FormControl fullWidth>
              <FormLabel>Mobile Number</FormLabel>
              <div
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="mobileRef"
              >
                <p
                  style={{
                    position: "absolute",
                    fontSize: "18px",
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    color: "#989898",
                    lineHeight: "100%",
                    visibility: linkData.mobileNumber.length > 2 ? "hidden" : "",
                  }}
                >
                  Mobile Number
                </p>
                <PhoneInput
                  country={"in"}
                  value={linkData.mobileNumber}
                  onChange={handlePhoneChange}
                  placeholder="Phone Number"
                  countryCodeEditable={false}
                  disableDropdown={true}
                  autoFormat={true}
                  inputProps={{
                    name: "mobileNumber",
                    required: true,
                    autoFocus: true,
                    autoComplete: "off",
                  }}
                  inputStyle={{
                    backgroundColor: !isPhoneValid ? "transparent" : "transparent",
                  }}
                  dropdownStyle={{
                    height: !isEditClinet ? "150px" : "120px",
                    fontSize: "20px",
                    paddingTop: "10px",
                    width: "360px",
                    marginTop: "15px",
                    borderRadius: "5px",
                  }}
                  isValid={(inputNumber, country) => {
                    const isValid = handleValidation(inputNumber, country);
                    setIsPhoneValid(isValid);
                    return isValid;
                  }}
                />
              </div>
            </FormControl>
          </Grid>

          <Grid item lg={12} width={"100%"}>
            <FormControl fullWidth>
              <FormLabel>Client Name</FormLabel>
              <OutlinedInput
                spellCheck={false}
                autoFocus={false}
                autoComplete="off"
                type="text"
                value={linkData.clientName}
                onChange={handleOnChangeEvent}
                placeholder="Client Name"
                name="clientName"
                id="clientName"
                readOnly={isAlredyFetch}
              />
            </FormControl>
          </Grid>

          {!isEditClinet && (
            <Grid item lg={12} width={"100%"}>
              <FormControl fullWidth>
                <FormLabel>Email</FormLabel>
                <OutlinedInput
                  spellCheck={false}
                  autoFocus={false}
                  autoComplete="off"
                  type="text"
                  value={linkData.clientEmail}
                  onChange={handleOnChangeEvent}
                  placeholder="Email address"
                  name="clientEmail"
                  id="clientEmail"
                  // readOnly={isAlredyFetch}
                />
              </FormControl>
            </Grid>
          )}

          {!isEditClinet && (
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginLeft: "20px",
                marginTop: "15px",
              }}
            >
              {/* Book Type */}

              <div style={{ flex: 1, minWidth: "190px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <FormLabel>Book Type</FormLabel>
                <CustomSelect
                  value={linkData.bookType}
                  onChange={handleOnChangeEvent}
                  options={["B2C Quote", "B2B Quote","CTWA Quote"]}
                  placeholder={"Select Book Type"}
                  menuStyles={{
                    maxHeight: "200px",
                    width: "fit-content",
                    overflowY: "auto",
                    justifyContent: "center !important",
                  }}
                  customStyles={{
                    height: "50px",
                  }}
                  width="100%"
                  name="bookType"
                />
              </div>

              {/* Hours – if not editing */}

              <Grid item lg={7} md={6} sm={3} xs={3} xl={9}>
                <FormControl>
                  <FormLabel>Hours</FormLabel>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <OutlinedInput
                      sx={{ width: "60px", textAlign: "center" }}
                      autoComplete="off"
                      value={linkData.hours}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,2}$/.test(value)) {
                          const numericValue = parseInt(value, 10);
                          if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 72) {
                            handleOnChangeEvent(e);
                          } else if (value === "") {
                            handleOnChangeEvent(e);
                          }
                        }
                      }}
                      placeholder="HH"
                      name="hours"
                      id="hours"
                      type="text"
                      inputProps={{
                        maxLength: 2,
                        inputMode: "numeric",
                      }}
                    />
                    <Typography className="catalogue-share-link-modal-hours">Between 1 To 72 Hours</Typography>
                  </Box>
                </FormControl>
              </Grid>
            </div>
          )}

          <Grid item lg={12} display="flex" justifyContent="center" sx={{ width: "100%", marginTop: "-15px" }}>
            <CustomButton
              variant="contained"
              disabled={
                (updateClient?.clientName === linkData.clientName && updateClient?.mobileNumber === linkData.mobileNumber) ||
                linkData.clientName === "" ||
                (!isEditClinet && linkData.hours === "") ||
                linkData.mobileNumber === "" ||
                !isPhoneValid ||
                (!isEditClinet && linkData.bookType === "") ||
                isLoading
                // linkData.mobileNumber.length < 12
              }
              onClick={handleSubmitForm}
            >
              {isLoading ? (isEditClinet ? "Saving..." : "Sharing...") : isEditClinet ? "Save Details" : "Add Number & Share"}
            </CustomButton>
          </Grid>
        </Grid>
      </Modal>
    </ThemeProvider>
  );
}

export default CatalogueAddAndEditClientDetails;
